__turbopack_context__.v({
  "backArrowIcon": "ZiQYwG_backArrowIcon",
  "button": "ZiQYwG_button",
  "hideLabel": "ZiQYwG_hideLabel",
  "label": "ZiQYwG_label",
});
